<template>
	<a-tooltip placement="top">
		<template
			v-if="tooltip"
			slot="title"
		>
			{{ name }}
		</template>
		<a-avatar
			v-if="image"
			:src="image"
			:shape="shape"
			:size="size"
			:style="{'background-color': color || $colors.warning}"
		/>
		<a-avatar
			v-else
			:size="size"
			:shape="shape"
			class="font-weight-bold"
			:style="{ backgroundColor: color || $colors.warning, 'font-size': `${fontSize}px`}"
		>
			{{ letters }}
		</a-avatar>
	</a-tooltip>
</template>

<script>
export default {
	name: 'GAvatar',
	props: {
		user: {
			type: Object,
			default: null
		},
		name: {
			type: String,
			default: ''
		},
		// MISC
		shape: {
			type: String,
			default: 'circle'
		},
		size: {
			type: [Number, String],
			default: 50
		},
		fontSize: {
			type: [Number, String],
			default: 16
		},
		color: {
			type: String,
			default: null
		},
		tooltip: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		image() {
			if (this.user) return this.$gestios.avatars(this.user.ID);
			return false;
		},
		letters() {
			return this.name.split(' ').map((n) => n.substring(0, 1)).splice(0, 2).join('');
		}
	}
};
</script>
